import VueRouter from 'vue-router'
import Vue from 'vue'
import home from '../view/homenew'
import sence from '../view/sence'
import download from '../view/downloadnew'
import featurenewsm from '../view/featurenewsm'
import featurenewfof from '../view/featurenewfof'
import register from '../view/register'
import features from '../view/features'
Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const routes = [{
        path: '/home',
        component: home
    },
    {
        path: '/download',
        component: download
    },
    {
        path: '/sence',
        component: sence
    },
    {
        path: '/features',
        component: features,
        children: [{
                path: 'featurenewsm/:id',
                component: featurenewsm,
                name: 'featurenewsm'
            },
            {
                path: 'featurenewfof/:id',
                component: featurenewfof,
                name: 'featurenewfof'
            },
            {
                path: "",
                component: featurenewsm,
                name: 'features'
            },
        ]
    },
    {
        path: '/features',
        redirect: '/features/featurenewsm/channel'
    },
    {
        path: '/register',
        component: register
    },
    {
        path: '*',
        redirect: '/home'
    }
]
const router = new VueRouter({
    mode: 'hash',

    routes
})
export default router